module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "basket col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "basket-list col-lg-9 col-md-12 col-xs-12"
  }, [(_vm.getBasket.basketType) ? _c('div', {
    staticClass: "basket-status"
  }, [_c('i', {
    staticClass: "fas fa-lock fa-1x"
  }), _vm._v("\n                " + _vm._s(_vm.$t("basket.statusBasket").replace("{status}", _vm.getBasket.basketType.terms.name[_vm.$t("trad")].value)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "basket-list-content"
  }, [(_vm.getBasket.name) ? _c('h1', {
    staticClass: "basket-list-title"
  }, [_vm._v(_vm._s(_vm.$t("basket.titleDetails")) + " '" + _vm._s(_vm.getBasket.name) + "'")]) : _vm._e(), _vm._v(" "), _c('BasketList', {
    attrs: {
      "datasListBaskets": _vm.getBasket
    }
  })], 1)]), _vm._v(" "), (typeof _vm.getBasket.items !== 'undefined' && _vm.getBasket.items.length > 0) ? _c('div', {
    staticClass: "basket col-lg-3 col-md-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('BasketOrder', {
    attrs: {
      "datasListBaskets": _vm.getBasket
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17e3e595","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/basket/Basket.vue
// module id = 3037
// module chunks = 0